<template>
  <v-dialog v-model="dialogs.qualifications.show" persistent max-width="700px">
    <v-card>
      <v-card-title>
        <span class="text-h5">Add Education</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="formQualifications"
            v-model="formValidationQualification"
          >
            <v-row>
              <v-col cols="6">
                <v-select
                  v-model="dialogs.qualifications.data.level"
                  label="Level*"
                  :items="getCodeLabelSelectItems('qualification')"
                  color="companyPrimary"
                  :rules="[rules.required]"
                  @change="adjustInstituteId()"
                />
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="dialogs.qualifications.data.instituteId"
                  label="Institute"
                  :items="institutesList"
                  :disabled="dialogs.qualifications.data.level === 1"
                  color="companyPrimary"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="dialogs.qualifications.data.faculty"
                  label="Faculty*"
                  color="companyPrimary"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="dialogs.qualifications.data.course"
                  label="Course*"
                  color="companyPrimary"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="3">
                <BaseDatePicker
                  v-model="dialogs.qualifications.data.date"
                  label="Grad.Date*"
                  text-field-class="mr-3"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="dialogs.qualifications.data.mark"
                  label="Mark*"
                  type="number"
                  hide-spin-buttons
                  color="companyPrimary"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="dialogs.qualifications.data.markScale"
                  label="Mark Scale*"
                  type="number"
                  hide-spin-buttons
                  color="companyPrimary"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="dialogs.qualifications.data.cumLaude"
                  label="Cum Laude"
                  color="companyPrimary"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close_dialog_qualifications()">Cancel</v-btn>
        <v-btn
          :disabled="!formValidationQualification"
          color="info"
          text
          @click="add_item_qualifications()"
          >Add</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getCodeLabelSelectItems } from "@/utils/enums";
import { validationRules } from "@/utils/validation-rules";
import BaseDatePicker from "@/components/base/BaseDatePicker.vue";

export default {
  name: "RegistrationAddEducationDialog",
  components: {
    BaseDatePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    qualifications: {
      type: Array,
      default: () => [],
    },
    institutesList: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["add-item-qualifications", "close-dialog-qualifications", "dialogs"],
  data() {
    return {
      formValidationQualification: true,
      getCodeLabelSelectItems,

      rules: { ...validationRules },
      showQualiDatePicker: false,
    };
  },
  computed: {
    dialogs: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("dialogs", value);
      },
    },
  },
  methods: {
    adjustInstituteId() {
      if (this.dialogs.qualifications.data.level === 1) {
        this.dialogs.qualifications.data.instituteId = 1;
      }
    },
    add_item_qualifications() {
      this.$emit("add-item-qualifications");
    },
    close_dialog_qualifications() {
      this.$emit("close-dialog-qualifications");
    },
  },
};
</script>
